import moment from "moment";
import { FIELD_ICON } from "../styles/media";
import { FIELDS, CITIES, PAYMENT_METHOD, SERVICES } from "../utils/constants";
import { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import ModalContainer from "../../containers/shared/ModalContainer";
import NormalButton from "../shared/NormalButton";
import WorkerModalContainer from "../../containers/shared/WorkerModalContainer";
import SelectField from "../shared/SelectField";
import MultiSelect from "../shared/MultiSelect";
import GetRequestStyle from "../helpers/GetRequestStyle";
import { UserContext } from "../../App";
import { useTranslation } from "react-i18next";

const RequestCard = ({request,newRequest=false,workersOptions=[],handleAddWorkerAction,handleAcceptFavoriteWorkerAction,handleRejectRequestAction,forceCloseModal=false}) => {
    const { t, i18n } = useTranslation();

    const [addWorkerToRequset, setAddWorkerToRequset] = useState(false);
    const [isButtonDisabled, setIsButtonDisabled] = useState(true);
    const [selectedWorker, setSelectedWorker] = useState(null);
    const [rejectRequestModal, setRejectRequestModal] = useState(false);

    const {fields} = useContext(UserContext);

    useEffect(()=>{
        if(moment) {
            moment?.locale('en-US');
        }
    },[])

    const getServiceName = (list,code) => {
        return SERVICES?.find(s=>s?.field?.code === request?.field)?.maintenanceListPerDevice?.find(m=>m?.device?.code === list)?.maintenanceList?.find(l=>l?.code === code)?.name || '-';
    }

    const handleCloseModal = () => {
        setAddWorkerToRequset(false);
       setRejectRequestModal(false); 
    }

    const handleClickAddWorker = () => {
        setSelectedWorker(null);
        setAddWorkerToRequset(true);
    }

    useEffect(()=>{
        if(selectedWorker) {
            setIsButtonDisabled(false);
        } else {
            setIsButtonDisabled(true);
        }
    },[selectedWorker])

    useEffect(()=>{
        if(forceCloseModal) {
            setAddWorkerToRequset(false);
            setRejectRequestModal(false);
        }
    },[forceCloseModal])



    
    const handleRejectRequest = () => {
        setAddWorkerToRequset(false);
        setRejectRequestModal(true);
    }

    // console.log(isButtonDisabled);


    return (
        <>
        <div className={`w-full sm:w-[calc(50%-8px)] lg:w-[calc(33.3333%-12px)] bg-white rounded-[12px] p-[12px] relative pb-[60px] ${(request?.status === 'pending-favorite-worker-approval' || (request?.status !== 'pending-favorite-worker-approval' && request?.requestedFavoriteWorker?._id)) ? 'border-[1px] border-danger' : ''}`}>
            <div className="flex flex-nowrap justify-between items-center pb-[12px] border-b-[1px] border-grey-200">
                <div className="w-[50%]">
                    <div className="inline-block me-[4px]">
                        {FIELD_ICON(request?.field,16,16,'fill-blue')}
                    </div>
                    <div className="inline-block text-blue font-[600] text-[16px] leading-[24px]">
                        {fields?.find(f=>f?.field?.code === request?.field)?.field?.name?.[i18n.language === 'ar' ? 'ar' : 'en'] || fields?.find(f=>f?.field?.code === request?.field)?.field?.name?.ar}
                    </div>
                </div>
                <div className="w-[50%] text-end font-[500] text-[14px] text-grey-600">
                    {t('requestCard.since')} {moment(request?.createdAt).format('DD/MM/YYYY')}
                </div>
            </div>
            <div className="pt-[12px]">
                
                {request?.status === 'pending-favorite-worker-approval' ? <div className="pb-[12px]">
                    <div className="h-[32px] leading-[32px] bg-danger/10 rounded-[20px] text-center font-[500] text-[16px] text-grey-600">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="inline-block me-[4px]">
                        <path d="M16.44 3.09961C14.63 3.09961 13.01 3.97961 12 5.32961C10.99 3.97961 9.37 3.09961 7.56 3.09961C4.49 3.09961 2 5.59961 2 8.68961C2 9.87961 2.19 10.9796 2.52 11.9996C4.1 16.9996 8.97 19.9896 11.38 20.8096C11.72 20.9296 12.28 20.9296 12.62 20.8096C15.03 19.9896 19.9 16.9996 21.48 11.9996C21.81 10.9796 22 9.87961 22 8.68961C22 5.59961 19.51 3.09961 16.44 3.09961Z" fill="#F04438"/>
                    </svg>
                    {t('requestCard.favTechReq')}
                    </div>
                </div> : ''}
                <div className="text-center mb-[10px] h-[24px]">
                    {request?.status !== 'pending-favorite-worker-approval' && request?.requestedFavoriteWorker?._id ? <div className="inline-block bg-grey-100 h-[22px] px-[8px] leading-[22px] rounded-[20px] me-[8px] text-grey-600 text-[12px] font-[500]">
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="inline-block me-[4px]">
                                <path d="M16.44 3.09961C14.63 3.09961 13.01 3.97961 12 5.32961C10.99 3.97961 9.37 3.09961 7.56 3.09961C4.49 3.09961 2 5.59961 2 8.68961C2 9.87961 2.19 10.9796 2.52 11.9996C4.1 16.9996 8.97 19.9896 11.38 20.8096C11.72 20.9296 12.28 20.9296 12.62 20.8096C15.03 19.9896 19.9 16.9996 21.48 11.9996C21.81 10.9796 22 9.87961 22 8.68961C22 5.59961 19.51 3.09961 16.44 3.09961Z" fill="#F04438"/>
                            </svg>
                            {t('requestCard.favTechReq')}
                        </div> : ''}
                    {newRequest && <div className="inline-block bg-[#0CB450]/10 h-[22px] px-[8px] leading-[22px] rounded-[20px] me-[8px] text-[#0CB450] text-[12px] font-[500]">{t('requestCard.new')}</div>}
                    {request?.customer?.activeSubscription && request?.customer?.activeSubscription?.status === 'active' && <div className="inline-block bg-[#FBA834]/10 h-[22px] px-[8px] leading-[22px] rounded-[20px] me-[8px] text-[#FBA834] text-[12px] font-[500]">{t('requestCard.fanniHappy')}</div>}
                    {request?.business?._id && <div className="inline-block bg-[#FBA834]/10 h-[22px] px-[8px] leading-[22px] rounded-[20px] me-[8px] text-[#FB00FF] text-[12px] font-[500]">{t('requestCard.fanniBusiness')}</div>}
                </div>
                <div className="text-[16px] text-grey-900 font-[500] leading-[24px] mb-[8px]">
                    <span className="text-blue text-[14px] font-[400] me-[4px]">
                        #
                            {t('requestCard.requestNum')}
                    </span>
                    {request?.requestPrettyId}
                </div>
                <div className="text-[16px] text-grey-900 font-[500] leading-[24px] mb-[8px]">
                    <span className="text-blue text-[14px] font-[400] me-[4px]">
                        <img src="/assets/images/requestinfo-status.svg" alt="" className="inline-block max-w-[12px] me-[3px]" />
                        {t('requestCard.requestStatus')} 
                    </span>
                    {GetRequestStyle(request?.status)}
                    {!['canceled','done','reviewed','timed-out'].includes(request?.status) && request?.isRescheduled ?
                        <div className="inline-block bg-[#8d0cb4]/10 h-[22px] px-[8px] leading-[22px] rounded-[20px] ms-[8px] text-[#8d0cb4] text-[12px] font-[500]">{t('requestCard.scheduledReq')}</div>
                    : ''}
                </div>
                {!['canceled','done','reviewed','timed-out'].includes(request?.status) && request?.isRescheduled ? <div className="text-[14px] text-grey-900 font-[500] leading-[24px] mb-[8px]">
                    <span className="text-blue text-[14px] font-[400] me-[4px]">
                        <img src="/assets/images/requestinfo-status.svg" alt="" className="inline-block max-w-[12px] me-[3px]" />
                        {t('requestCard.scheduleDetails')}
                    </span>
                     {t('requestCard.scheduledTo')} {request?.rescheduleInfo?.scheduledFor ? new Date(request?.rescheduleInfo?.scheduledFor).toLocaleDateString('en-GB', {year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', hour12: true,}) : t('requestCard.notSpecified')} {t('requestCard.by')} {request?.rescheduleInfo?.rescheduledBy?.name ? request?.rescheduleInfo?.rescheduledBy?.name : t('requestCard.unknown')}
                </div> : ''}
                <div className="text-[16px] text-grey-900 font-[500] leading-[24px] mb-[8px]">
                    <span className="text-blue text-[14px] font-[400] me-[4px]">
                        <img src="/assets/images/worker-name-icon.svg" alt="" className="inline-block me-[3px]" />
                        {t('requestCard.customerName')}
                    </span>
                    {request?.customer?.name} { (request?.status === 'active' || request?.status === 'postponed') && request?.customer?.username ? <span>- <span dir="ltr">{`[ ${request?.customer?.username} ]`}</span></span> : ''}
                </div>

                <div className="text-[16px] text-grey-900 font-[500] leading-[24px] mb-[8px]">
                    <span className="text-blue text-[14px] font-[400] me-[4px]">
                        <img src="/assets/images/request-payment-icon.svg" alt="" className="inline-block me-[3px]" />
                        {t('requestCard.paymentMethod')}
                    </span>
                    {PAYMENT_METHOD[request?.paymentMethod]?.[i18n.language === 'ar' ? 'ar' : 'en'] || PAYMENT_METHOD[request?.paymentMethod]?.ar || '-'}
                </div>

                <div className="text-[16px] text-grey-900 font-[500] leading-[24px] mb-[8px]">
                    <span className="text-blue text-[14px] font-[400] me-[4px]">
                        <img src="/assets/images/worker-city-icon.svg" alt="" className="inline-block me-[3px]" />
                        {t('requestCard.city')}
                    </span>
                    {CITIES[request?.city]?.[i18n.language === 'ar' ? 'ar' : 'en'] || CITIES[request?.city]?.ar || '-'}
                </div>

                <div className="text-[16px] text-grey-900 font-[500] leading-[24px] mb-[8px]">
                    <span className="text-blue text-[14px] font-[400] me-[4px]">
                        <img src="/assets/images/worker-location-icon.svg" alt="" className="inline-block me-[3px]" />
                        {t('requestCard.district')}
                    </span>
                    {request?.district?.[i18n.language === 'ar' ? 'ar' : 'en'] || request?.district?.ar || '-'}
                </div>

                <div className="flex flex-nowrap bg-white px-[16px]">
                    <div className="w-[50%] h-[21px] leading-[21px] text-grey-900 text-[14px] font-[500]">{t('requestCard.service')}</div>
                    <div className="w-[25%] h-[21px] leading-[21px] text-grey-900 text-[14px] font-[500] text-center">{t('requestCard.quantity')}</div>
                    <div className="w-[25%] h-[21px] leading-[21px] text-grey-900 text-[14px] font-[500] text-end">{t('requestCard.cost')}</div>
                </div>
                {request?.maintenanceListHistory?.length > 0 ? request?.maintenanceListHistory?.map((item,index)=> {
                    return (<div key={'maintenanceList-'+index} className="flex flex-nowrap bg-white px-[16px] mt-[10px]">
                    <div className="w-[50%] h-[21px] leading-[21px] text-grey-900 text-[14px] font-[500]  truncate" title={item?.maintenance?.name ? item?.maintenance?.name : getServiceName(item?.deviceCode,item?.maintenanceCode)}>{item?.maintenance?.name ? item?.maintenance?.name : getServiceName(item?.deviceCode,item?.maintenanceCode)}</div>
                    <div className="w-[25%] h-[21px] leading-[21px] text-grey-900 text-[14px] font-[500] text-center">1</div>
                    <div className="w-[25%] h-[21px] leading-[21px] text-grey-900 text-[14px] font-[500] text-end">{item?.cost || '0'} <img src="/assets/images/pack-sar.svg" alt="" className="inline-block align-baseline ms-[3px] w-[11px]" /></div>
                </div>)})
                : <div className=" bg-white px-[16px] text-center leading-[37px] text-grey-900 text-[14px] font-[500]"> {t('requestCard.noServices')} </div>}

            </div>

            <div className="border-t-[1px] border-grey-200 mt-[4px] absolute bottom-[12px] left-[12px] right-[12px]">
                {newRequest ?
                    request?.status === '' 
                        ?   <div className="mt-[12px] h-[24px] flex flex-nowrap cursor-pointer" onClick={()=> handleClickAddWorker()}>
                                <div className="w-[50%] text-darkBlue text-[16px] font-[700] leading-[24px]">{request?.requestedFavoriteWorker?.name || t('requestCard.unknown')}</div>
                                <div className="w-[50%] text-end text-[16px] text-grey-900 font-[500]">
                                    {t('requestCard.details')}
                                    <img src="/assets/images/worker-details-icon.svg" alt="" className="inline-block align-baseline ms-[8px]" />
                                </div>
                            </div>
                        :   <div className="mt-[12px] h-[24px] flex flex-nowrap cursor-pointer" onClick={()=> handleClickAddWorker()}>    
                                <div className="w-[50%] text-darkBlue text-[16px] font-[700] leading-[24px]">{t('requestCard.chooseTech')}</div>
                                <div className="w-[50%] text-end"><img src="/assets/images/worker-details-icon.svg" alt="" className="inline-block align-baseline" /></div>
                            </div>
                 :
                    <Link to={`/${i18n?.language || 'ar'}/requests/${request?.requestPrettyId}?business=${request.business?._id || ''}`} className="mt-[12px] h-[24px] flex flex-nowrap cursor-pointer">
                        <div className="w-[50%] text-darkBlue text-[16px] font-[700] leading-[24px]">{t('requestCard.showDetails')}</div>
                        <div className="w-[50%] text-end"><img src="/assets/images/worker-details-icon.svg" alt="" className="inline-block align-baseline" /></div>
                    </Link>
                }
            </div>




        </div>


        {addWorkerToRequset && <WorkerModalContainer heading={t('requestCard.chooseTech')} handleCloseModal={handleCloseModal}>
          <div className="">
            <div className="w-full">
                <div className="flex flex-nowrap justify-between items-center pb-[12px] border-b-[1px] border-grey-200">
                    <div className="w-[50%]">
                        <div className="inline-block me-[4px]">
                            {FIELD_ICON(request?.field,16,16,'fill-blue')}
                        </div>
                        <div className="inline-block text-blue font-[600] text-[16px] leading-[24px]">
                        {fields?.find(f=>f?.field?.code === request?.field)?.field?.name?.[i18n.language === 'ar' ? 'ar' : 'en'] || fields?.find(f=>f?.field?.code === request?.field)?.field?.name?.ar}
                    </div>
                    </div>
                    <div className="w-[50%] text-end font-[500] text-[14px] text-grey-600">
                        {t('requestCard.since')} {moment(request?.createdAt).format('DD/MM/YYYY')}
                    </div>
                </div>
                <div className="pt-[12px]">
                    <div className="text-center mb-[10px] h-[24px]">
                        {request?.status === 'pending-favorite-worker-approval' && <div className="inline-block bg-grey-100 h-[22px] px-[8px] leading-[22px] rounded-[20px] me-[8px] text-grey-600 text-[12px] font-[500]">
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="inline-block me-[4px]">
                                <path d="M16.44 3.09961C14.63 3.09961 13.01 3.97961 12 5.32961C10.99 3.97961 9.37 3.09961 7.56 3.09961C4.49 3.09961 2 5.59961 2 8.68961C2 9.87961 2.19 10.9796 2.52 11.9996C4.1 16.9996 8.97 19.9896 11.38 20.8096C11.72 20.9296 12.28 20.9296 12.62 20.8096C15.03 19.9896 19.9 16.9996 21.48 11.9996C21.81 10.9796 22 9.87961 22 8.68961C22 5.59961 19.51 3.09961 16.44 3.09961Z" fill="#F04438"/>
                            </svg>
                            {t('requestCard.favTechReq')}
                        </div>}
                        {newRequest && <div className="inline-block bg-[#0CB450]/10 h-[22px] px-[8px] leading-[22px] rounded-[20px] me-[8px] text-[#0CB450] text-[12px] font-[500]">{t('requestCard.new')}</div>}
                        {request?.customer?.activeSubscription && request?.customer?.activeSubscription?.status === 'active' && <div className="inline-block bg-[#FBA834]/10 h-[22px] px-[8px] leading-[22px] rounded-[20px] me-[8px] text-[#FBA834] text-[12px] font-[500]">{t('requestCard.fanniHappy')}</div>}
                        {request?.business?._id && <div className="inline-block bg-[#FBA834]/10 h-[22px] px-[8px] leading-[22px] rounded-[20px] me-[8px] text-[#FBA834] text-[12px] font-[500]">{t('requestCard.fanniBusiness')}</div>}
                    </div>
                    <div className="text-[16px] text-grey-900 font-[500] leading-[24px] mb-[8px]">
                        <span className="text-blue text-[14px] font-[400] me-[4px]">
                            #
                             {t('requestCard.requestNum')}
                        </span>
                        {request?.requestPrettyId}
                    </div>
                    <div className="text-[16px] text-grey-900 font-[500] leading-[24px] mb-[8px]">
                        <span className="text-blue text-[14px] font-[400] me-[4px]">
                            <img src="/assets/images/worker-name-icon.svg" alt="" className="inline-block me-[3px]" />
                            {t('requestCard.customerName')}
                        </span>
                        {request?.customer?.name} { (request?.status === 'active' || request?.status === 'postponed') && request?.customer?.username ? <span>- <span dir="ltr">{`[ ${request?.customer?.username} ]`}</span></span> : ''}
                    </div>

                    <div className="text-[16px] text-grey-900 font-[500] leading-[24px] mb-[8px]">
                        <span className="text-blue text-[14px] font-[400] me-[4px]">
                            <img src="/assets/images/request-payment-icon.svg" alt="" className="inline-block me-[3px]" />
                            {t('requestCard.paymentMethod')}
                        </span>
                        {PAYMENT_METHOD[request?.paymentMethod]?.[i18n.language === 'ar' ? 'ar' : 'en'] || PAYMENT_METHOD[request?.paymentMethod]?.ar || '-'}
                    </div>

                    <div className="text-[16px] text-grey-900 font-[500] leading-[24px] mb-[8px]">
                        <span className="text-blue text-[14px] font-[400] me-[4px]">
                            <img src="/assets/images/worker-city-icon.svg" alt="" className="inline-block me-[3px]" />
                            {t('requestCard.city')}
                        </span>
                        {CITIES[request?.city]?.[i18n.language === 'ar' ? 'ar' : 'en'] || CITIES[request?.city]?.ar || '-'}
                    </div>

                    <div className="text-[16px] text-grey-900 font-[500] leading-[24px] mb-[8px]">
                        <span className="text-blue text-[14px] font-[400] me-[4px]">
                            <img src="/assets/images/worker-location-icon.svg" alt="" className="inline-block me-[3px]" />
                            {t('requestCard.district')}
                        </span>
                        {request?.district?.[i18n.language === 'ar' ? 'ar' : 'en'] || request?.district?.ar || '-'}
                    </div>

                    <div className="flex flex-nowrap bg-white px-[16px]">
                        <div className="w-[50%] h-[21px] leading-[21px] text-grey-900 text-[14px] font-[500]">{t('requestCard.service')}</div>
                        <div className="w-[25%] h-[21px] leading-[21px] text-grey-900 text-[14px] font-[500] text-center">{t('requestCard.quantity')}</div>
                        <div className="w-[25%] h-[21px] leading-[21px] text-grey-900 text-[14px] font-[500] text-end">{t('requestCard.cost')}</div>
                    </div>
                    {request?.maintenanceListHistory?.length > 0 ? request?.maintenanceListHistory?.map((item,index)=> {
                        return (<div key={'maintenanceList-'+index} className="flex flex-nowrap bg-white px-[16px] mt-[10px]">
                        <div className="w-[50%] h-[21px] leading-[21px] text-grey-900 text-[14px] font-[500]">{getServiceName(item?.deviceCode,item?.maintenanceCode)}</div>
                        <div className="w-[25%] h-[21px] leading-[21px] text-grey-900 text-[14px] font-[500] text-center">1</div>
                        <div className="w-[25%] h-[21px] leading-[21px] text-grey-900 text-[14px] font-[500] text-end">{item?.cost || '0'} <img src="/assets/images/pack-sar.svg" alt="" className="inline-block align-baseline ms-[3px] w-[11px]" /></div>
                    </div>)})
                    : <div className=" bg-white px-[16px] text-center leading-[37px] text-grey-900 text-[14px] font-[500]"> {t('requestCard.noServices')} </div>}

                </div>
            </div>
            <div className="">
                {request?.status === 'pending-favorite-worker-approval' 
                ?   <div className="mt-[20px] pt-[10px] border-t-[1px] border-grey-200">
                        <div className="font-[500] text-[16px] text-grey-600 leading-[24px]">{t('requestCard.reqFavTech')}</div>
                        <div className="flex flex-nowrap leading-[24px] mt-[8px]">
                                <div className="w-[50%] text-[16px] font-[500] text-grey-900">{request?.requestedFavoriteWorker?.name || t('requestCard.unknown')}</div>
                                <div className="w-[50%] text-end">{request?.requestedFavoriteWorker?.status === 'available' ? <div className="text-darkBlue text-[12px] font-[500]"><span className="w-[8px] h-[8px] me-[4px] rounded-full bg-darkBlue inline-block"></span>{t('requestCard.available')}</div> : <div className="opacity-50 text-darkBlue text-[12px] font-[500]"><span className="w-[8px] h-[8px] me-[4px] rounded-full bg-darkBlue inline-block"></span>{t('requestCard.unavailable')}</div> }</div>
                        </div>
                        {request?.rescheduleInfo?.scheduledFor && <div className="flex flex-nowrap leading-[43px] h-[43px] bg-grey-200 rounded-[8px] px-[4px] text-grey-600 mt-[12px]">
                                <div className="w-[50%] text-[18px] font-[700]">{t('requestCard.startDate')}</div>
                                <div className="w-[50%] text-end text-[18px] font-[400]">{moment(request?.rescheduleInfo?.scheduledFor).format('DD/MM/YYYY HH:mm A')}</div>
                        </div>}

                    </div>
                :   <div className="mt-[20px] pt-[10px] border-t-[1px] border-grey-200">
                        <MultiSelect isMulti={false} label={t('requestCard.chooseTech')} placeholder={t('requestCard.searchTech')} options={workersOptions} value={selectedWorker} onChange={(option)=>{setSelectedWorker(option.value )}} />
                    </div>}
            </div>
            <div className="w-full pt-[15px] text-end">
                {request?.status === 'pending-favorite-worker-approval' 
                ?   <div className="border-t-[1px] border-grey-200 pt-[12px]">
                        <NormalButton label={t('requestCard.close')} color={'!bg-[transparent] !text-grey-400'} isDisabled={false} onClick={handleCloseModal} />
                        <NormalButton label={t('requestCard.rejectReq')} color={'!bg-grey-100 !text-danger !me-[16px]'} isDisabled={false} onClick={()=>handleRejectRequest()} />
                        <NormalButton label={t('requestCard.assignTech')}  isDisabled={false} onClick={()=>handleAcceptFavoriteWorkerAction(request?._id)} />
                    </div>
                :   <>
                        <NormalButton label={t('requestCard.cancel')} color={'!bg-[transparent] !text-grey-400'} isDisabled={false} onClick={handleCloseModal} />
                        <NormalButton label={t('requestCard.assignTech')}  isDisabled={isButtonDisabled} onClick={()=>handleAddWorkerAction(request?._id,selectedWorker, request?.business)} />
                    </>}
            </div>
          </div>
        </WorkerModalContainer>}


        {rejectRequestModal && <WorkerModalContainer heading={t('requestCard.rejectReq')} handleCloseModal={handleCloseModal}>
          <div className="">
            <div className="w-full">
                <div className="flex flex-nowrap justify-between items-center pb-[12px] border-b-[1px] border-grey-200">
                    <div className="w-[50%]">
                        <div className="inline-block me-[4px]">
                            {FIELD_ICON(request?.field,16,16,'fill-blue')}
                        </div>
                        <div className="inline-block text-blue font-[600] text-[16px] leading-[24px]">
                        {fields?.find(f=>f?.field?.code === request?.field)?.field?.name?.[i18n.language === 'ar' ? 'ar' : 'en'] || fields?.find(f=>f?.field?.code === request?.field)?.field?.name?.ar}
                    </div>
                    </div>
                    <div className="w-[50%] text-end font-[500] text-[14px] text-grey-600">
                        {t('requestCard.since')} {moment(request?.createdAt).format('DD/MM/YYYY')}
                    </div>
                </div>
                <div className="pt-[12px]">
                    <p className="font-[500] text-grey-900 text-[14px]">{t('requestCard.confirmReject')}</p>
                </div>
            </div>
            <div className="w-full pt-[15px] text-end">
                <NormalButton label={t('requestCard.closeAlt')} color={'!bg-[transparent] !text-grey-400'} isDisabled={false} onClick={handleCloseModal} />
                <NormalButton label={t('requestCard.rejectReq')} color={'!bg-grey-100 !text-danger !me-[16px]'} isDisabled={false} onClick={()=>handleRejectRequestAction(request?._id)} />
            </div>
          </div>
        </WorkerModalContainer>}

        </>
    )
}

export default RequestCard;